import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.catalogos.unidad_de_medida = {
      ...state.app.catalogos.unidad_de_medida,
      filters: {
        ...state.app.catalogos.unidad_de_medida.filters,
        ...meta,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.catalogos.unidad_de_medida;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      page: meta.page || 1,
    };

    const response = await Http.get('catalogos/unidades-de_medida', { params });

    store.setState((state) => {
      state.app.catalogos.unidad_de_medida = {
        ...state.app.catalogos.unidad_de_medida,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.catalogos.unidad_de_medida.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.catalogos.unidad_de_medida.busy = false;
      state.app.catalogos.unidad_de_medida.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.catalogos.unidad_de_medida = {
      ...initialState,
    };
  });
};

const UnidadDeMedidaSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default UnidadDeMedidaSuggestionsStore;
